<template>
  <div class="container" >
    <div class="memory-box" style="margin: auto; width: 100%; margin-top: 10px;">
      <div class="top-bar" style="padding-left: 17px;">
        Group Photo
      </div>
      <div>
        <Memory />
      </div>
    </div>

    <div style="width: 100%;">
      <ul style="padding: 0px;">
        <li style="list-style-type: none;">
          <h3 class="titles" style="margin-top: 30px;">Research Interests</h3>
          <div style="border: 3px solid #CCCCCC; width: 250px"></div>
          <p>
            Machine Learning <br />
            Bioinformatics <br />
            Single cell and Spatial Genomics <br />
            AI for Science
          </p>
        </li>
      </ul>
    </div>

    <div style="width: 100%; margin: auto">
      <h3 class="titles">News</h3>
      <div style="border: 3px solid #CCCCCC; width: 250px"></div>
      <div style="width: 100%; margin: auto">
        <p >
          <b>· 2024-12: </b>
        </p>
        <p>
          New Paper! Our database CancerSRT, a spatially resolved transcriptomics database for human cancers was published at Journal of Genetics and Genomics!
        </p>

        <p >
          <b>· 2024-09: </b>
        </p>
        <p >
          We are looking for creative and highly motivated students to join our group.
          If you want to discuss potential opportunities, contact us.
        </p>
        <p >
          <b>· 2024-09: </b>
        </p>
        <p >
          The lab welcomes new students, Jianxing Zhang, Zhuoxin Yao, Zhipeng Tan and Rui Zhao.
        </p>
        <p>
        <p v-if="!showMore">
          <a href="#" @click.prevent="toggleShowMore">More News</a>
        </p>
        <div v-if="showMore">
        <p>
          <b>· 2024-06: </b>
        </p>
        <p>
          Congratulations to Yuying Huo on being awarded the Excellent Master thesis of Beijing Jiaotong University.
        </p>
        <p>
          <b>· 2024-06: </b>
        </p>
        <p>
          Congratulations to Yuying Huo, Jiakang Wang and Mengnan Gao on their graduation with master's degrees.
        </p>
        <!-- 收起按钮 -->
        <p>
          <a href="#" @click.prevent="toggleShowMore">Show Less</a>
        </p>
      </div>
        </p>
      </div>
    </div>
    <div style="margin-bottom: 50px;">
      <JoinUs />
    </div>

  </div>
</template>

<script>
import JoinUs from './JoinUs.vue'
import Resume from './Resume'
import Publications from './Publications'
import Softwares from './Softwares'
import Members from './Teacher'
import Contact from './Contact'
import Memory from './Memory'

export default {
  name: 'Home',
  components: { Memory, Contact, Members, Softwares, Publications, Resume, JoinUs },
  data () {
    return {
      showMore: false, // 控制展开和收起的状态
      start_div: true
    }
  },
  mounted () {
    this.start_div = false
  },
  methods: {
    toggleShowMore() {
      this.showMore = !this.showMore; // 切换状态
    },
  }
}
</script>

<style scoped>
.router-link-active,
.router-link-exact-active,
.router-link {
  text-decoration: none;
}

h4 {
  text-align: left;
  color: white;
  background-color: #005BAC;
  width: 100%;
  margin-bottom: 5px;
  margin-top: 5px;
  text-indent: 16px;
}

.titles {
  color: #005BAC;
  text-align: left;
  font-size: 28px;
  margin: 16px 0 0 0;
  padding: 0;
}

.container{
  margin: auto; 
  width: 1000px;
}

/* 框的样式 */
.memory-box {
  border-radius: 0px;
  margin-top: 20px;
  flex-direction: column;
  justify-content: flex-start;
  border: 2px solid #005BAC;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px;
  margin-bottom: 10px;
}

.top-bar {
  font-size: 26px;
  padding: 0px;
  width: 98.5%;
  background-color: #005BAC;
  color: white;
  text-align: left;
  margin-bottom: 10px;
}

p{
  font-size: 20px;
  text-align: left; 
  margin: 0px; 
  margin-left: 16px; 
  font-family: Arial;
  word-wrap: break-word; /* 自动换行 */
  word-break: break-word; /* 强制换行 */
  max-width: 100%; /* 保证不会超出屏幕宽度 */
  white-space: normal; /* 允许文字换行 */
}

b{
  font-size: 26px; 
  font-family: Arial
}
/* 响应式字体调整 */


@media screen and (max-width: 768px) {
  .container{
    width: 100%;
  }
  .titles {
    padding: 0px;
    font-size: 22px; /* 手机设备字体大小 */
  }

  .top-bar {
    font-size: 22px; /* 手机设备顶部字体大小 */
  }

  .memory-box {
 
  }

  .top-bar {
    
  }

  /* 调整新闻内容字体大小 */
  .news-text {
    font-size: 14px;
  }
  p{
  font-size: 16px;
  text-align: left; 
  margin: 0px; 
  margin-left: 16px; 
  font-family: Arial;
  word-wrap: break-word; /* 自动换行 */
  word-break: break-word; /* 强制换行 */
  max-width: 100%; /* 保证不会超出屏幕宽度 */
  white-space: normal; /* 允许文字换行 */
  }
  b{
  font-size: 22px; 
  font-family: Arial
}
}


@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    transform: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components2/Home.vue